export const fieldsIcons = {
	signature: 'fa-signature',
	textBox: 'fa-input-text',
	checkBox: 'fa-check-square',
	image: 'fa-image',
	GPS: 'fa-map-marker-alt',
	dateField: 'fa-calendar-alt',
	attachment: 'fa-paperclip',
	metadata: 'fa-info-circle',
	metaTag: 'fa-tag',
	Tags: 'fa-tags',
};
